"use client";

import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import { useDeviceType } from "@/shared/context/DeviceContext";
import { usePagination } from "@/shared/hooks/usePagination";
import type { TourAvailabilityItem } from "@/types/services/tour/apis/Availability";
import { useRef } from "react";
import TourCard from "./tourCard/TourCard";

interface TourListProps {
  searchParams: SearchParams;
  tours: TourAvailabilityItem[];
  searchId: string;
}

export default function TourList(props: TourListProps) {
  const { tours } = props;
  const deviceType = useDeviceType();

  const tourListRef = useRef(null);
  const toursList = usePagination<TourAvailabilityItem>(
    tours,
    tourListRef,
    null,
    {
      pageLimit: deviceType === "mobile" ? 2 : 4,
    },
  );

  return (
    <Flex className="flex-col space-y-4" ref={tourListRef}>
      <List
        items={toursList}
        renderItems={(tour) => <TourCard tour={tour} {...props} />}
      />
    </Flex>
  );
}
